module.exports = __webpack_public_path__ + "702664ddffd4fe72847637b0d00bb075.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipes/Assets/smoothie.png
// module id = 1347
// module chunks = 0